import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { Button } from '@isyc-react/form/modules/base/button';
import { FilterTableModal } from "./filter-modal";
import { useTranslation } from 'react-i18next';
import { nstable } from "../../../../i18n/namespaces";
export const FilterButton = props => {
  const {
    children
  } = props;
  const {
    t
  } = useTranslation(nstable.common);
  const [show, setShow] = React.useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setShow(true),
    className: "btn btn-outline-primary d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-filter text-primary"
  }), /*#__PURE__*/React.createElement("div", {
    className: "ms-2"
  }, t('table.controls.filter.button'))), /*#__PURE__*/React.createElement(FilterTableModal, {
    show: show,
    onHide: () => setShow(false)
  }, children));
};